import React from 'react';
import theme from './PriceDisplay.module.scss';
import { Trans } from '@lingui/react/macro';
import { ProfileCurrencyDisplay, ProjectCurrencyDisplay } from '../../currency';

export interface SimplePriceDisplayProps {
    currencyMode: 'project' | 'profile';
    basePrice?: number | null;
    finalPrice?: number | null;
    pricingFieldName?: string;
    pricingFieldUnit?: string;
}

export const SimplePriceDisplay: React.FC<SimplePriceDisplayProps> = ({
    currencyMode,
    basePrice,
    finalPrice,
    pricingFieldName,
    pricingFieldUnit,
}) => {
    if (finalPrice == null) {
        return (
            <div className={theme.price}>
                <Trans>Redacted</Trans>
            </div>
        );
    }
    const CurrencyComponent = currencyMode === 'project' ? ProjectCurrencyDisplay : ProfileCurrencyDisplay;

    return (
        <div className={theme.price}>
            {pricingFieldName && (
                <small>
                    <Trans>
                        Multiplied by {pricingFieldName} {pricingFieldUnit && <>({pricingFieldUnit})</>}
                    </Trans>
                </small>
            )}

            <div className={theme.final}>
                <CurrencyComponent value={finalPrice} />
            </div>

            {basePrice && basePrice > 0 ? (
                <div className={theme.base}>
                    (<CurrencyComponent value={basePrice} />)
                </div>
            ) : null}
        </div>
    );
};
